import TabloItem from './tablo-item';

export default class TabloList {
  isNotError = true;

  list = [];

  constructor(res) {
    if (!res || !Object.keys(res).length || !res.timeTable) {
      this.isNotError = false;
      return;
    }

    this.list = res.timeTable.map(item => new TabloItem({ tablo:item, dictionary: res.dictionaries }));
  }

  get isFull() {
    return this.list && this.list.length;
  }

  closeAll() {
    this.list.forEach(item => {
      item.opened = false;
    });
  }

  filterByTime(time, direction) {
    return this.list.filter(item => item[direction].checkTime(time));
  }
};